import SystemTooltip from "../SystemTooltip";
import { SystemsMapProps } from "../models/SystemIconData";
import useTooltipsControl from "@hooks/useTooltipsControl";

/* eslint-disable @next/next/no-img-element */
const CampaniaSystemsMap = ({ iconsData }: SystemsMapProps) => {
  const { toggle, opened } = useTooltipsControl();
  const openFirst = () => toggle("1");
  const openSecond = () => toggle("2");
  const openThird = () => toggle("3");

  return (
    <svg
      viewBox="0 0 513 480"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      id="campaniaDetail"
    >
      <path
        d="M94.0582 2.57026L102.259 3.21262L109.746 1.92791L116.521 1.64235L120.585 3.21262L127.217 4.56876L128.429 5.06844L129.356 5.56801L134.205 9.49367L142.477 13.3479L152.532 16.7026L168.148 22.9835L170.715 23.4119L174.994 23.626L176.491 24.4825L178.203 26.1955L179.914 29.9069L183.48 34.0468L190.824 34.6177L198.098 34.0468L199.382 34.475L200.38 35.26L202.163 37.9723L202.804 38.7576L203.66 39.3999L204.73 39.8996L205.942 40.1849L207.653 39.8996L209.508 39.1144L220.275 31.4059L222.129 29.4074L223.056 28.9792L224.696 28.6222L240.883 27.7657L242.523 27.1948L244.306 26.2669L247.159 24.0543L248.442 22.5552L249.226 21.1279L250.082 17.4162L250.51 16.2744L251.081 15.3465L252.008 14.6327L253.291 14.4186L255.216 14.9181L256.357 15.6318L257.356 16.3456L258.853 17.8447L260.565 19.1294L262.49 20.1285L263.631 20.4855L269.621 18.5582L276.68 14.704L285.808 11.7063L287.662 11.3494L290.087 10.2075L304.063 1L305.204 1.78513L311.693 5.06844L316.4 6.56726L317.683 7.56651L320.821 12.1345L322.033 13.6334L323.174 14.7755L328.379 17.2021L329.235 18.5582L329.948 20.7709L330.804 28.0513V29.9783L330.234 30.9777L329.52 31.6913L327.524 32.6192L326.811 33.4044L326.383 34.4036L326.169 35.4741L325.812 36.4735L325.17 37.2585L324.386 37.9011L323.602 38.6861L322.96 39.614L322.461 40.6132L322.318 42.1122L322.603 43.8251L323.887 48.1077L324.743 49.678L325.955 50.9627L328.736 52.5329L332.159 53.675L334.94 54.1032L337.792 56.6726L341.786 67.3077L344.709 67.0935L345.636 66.808L346.706 66.3083L347.562 65.5945L349.416 62.8824L350.271 62.3828L352.339 62.9537L360.682 67.5218L365.531 69.1633L366.958 70.02L368.526 71.6614L371.165 75.2302L372.163 77.1575L372.52 78.3707L372.163 79.156L371.521 79.7983L370.666 80.3692L367.528 81.3686L367.029 82.1536L367.385 83.2242L369.24 86.0079L369.453 87.2926L369.168 88.3632L368.669 89.2911L368.027 90.2191L365.817 92.4317L364.248 93.7878L357.545 102.139L357.046 103.138L356.903 104.209L357.117 105.279L357.616 106.136L359.114 107.421L370.666 114.13L371.45 114.844L372.876 116.342L375.729 121.053L377.012 121.624L378.795 121.981L402.042 122.909L404.466 122.552L405.892 120.91L406.677 120.197L407.746 120.054L409.173 120.625L412.31 123.194L420.083 128.262L445.54 135.257L450.175 144.321L450.746 149.389L449.462 153.814L445.611 162.38L443.187 171.516L441.547 175.013L438.48 178.082L430.209 183.792L425.788 185.791L400.901 187.504L400.116 191.715L399.118 194.998L399.261 199.28L399.617 201.493L400.473 204.134L400.687 205.419L399.831 208.488L395.624 213.127L399.118 216.625L400.259 217.196L401.329 218.124L401.828 218.837L401.471 220.122L401.115 221.05L400.972 222.049L401.685 223.048L402.042 224.048V225.475V227.26L403.04 229.686L403.682 238.394L404.181 240.178L405.037 242.32L407.033 245.888L408.317 247.673L409.458 248.815L413.38 251.099L415.091 252.384L415.804 253.169L418.728 257.523L419.441 258.236L425.217 261.448L426.501 261.805L430.565 262.448L431.706 262.947L432.562 263.59L432.99 264.732L433.132 266.23L432.633 268.372L431.991 269.585L431.136 270.442L428.355 272.083L427.499 272.726L426.715 273.511L423.933 277.793L423.292 279.292L423.006 280.291L422.792 281.362V282.076L423.078 283.218L423.719 284.217L425.36 285.359L426.928 285.787L429.852 286.287L432.205 287.001L434.131 288.071L437.482 290.926L440.335 293.995L440.976 294.852L446.895 309.127L447.109 310.626L446.824 312.91L446.182 315.551V316.479L446.039 317.621L446.325 319.048L446.824 320.618L448.25 322.759L449.248 323.973L450.246 324.972L451.958 326.257L454.953 327.899L456.664 329.112L457.663 330.54L460.8 336.82L462.44 338.319L463.866 339.033L465.079 338.89H466.362L467.503 339.247L468.501 339.747L469.999 341.246L472.638 344.601L477.059 349.026L477.986 349.668L479.055 350.096L480.196 350.382H484.047L485.117 350.739L486.115 351.238L486.97 351.809L488.468 353.308L489.752 354.95L490.179 356.734L491.463 368.868L492.105 371.081L493.032 373.008L493.602 373.864L494.315 374.649L496.098 375.934L501.018 378.646L501.874 379.289L502.587 380.074L504.299 382.643L505.012 383.5L505.796 384.214L509.148 386.855L510.574 388.425L511.073 389.495L511.501 390.709L511.857 392.422L512 393.921V395.348L511.715 396.49L510.859 399.417L508.648 404.413L505.582 406.269L504.227 407.553L502.373 410.051L501.161 411.336L500.02 412.193L498.023 413.121L496.169 414.263L495.385 414.905L494.458 415.976L492.034 419.402L490.037 421.472L489.395 422.542L489.039 423.898L489.181 426.111L490.037 430.179V431.536L489.181 434.176L483.476 445.168L481.337 448.095L479.055 450.664L478.913 451.735L479.555 453.234L480.41 453.947L481.123 454.375L482.05 454.661L482.835 455.018L482.549 456.945L478.699 461.584L474.563 458.23L473.065 455.946L472.851 451.735L469.429 453.376L450.674 452.52L444.542 455.089L440.477 459.015L432.633 468.865L424.076 477.287L419.298 479L412.167 478.144L406.32 475.36L396.408 468.508L393.556 467.794L391.274 469.079L388.778 470.007L386.068 470.435L383.287 470.292V468.008L387.637 464.154L383.43 455.803L375.8 447.523L369.667 443.812L364.676 441.671L348.631 425.683L345.066 424.112L340.859 424.826L333.442 427.182L328.879 426.539L325.741 424.541L320.464 418.545L310.124 409.623L308.342 409.124L306.345 406.84L297.289 405.055L294.508 403.985L293.296 398.489L299.285 389.567L300.854 382.572L299.072 377.005V373.936L301.425 372.508L304.348 371.794L306.844 370.01L308.912 367.726L310.481 365.442L312.691 353.951L308.983 341.959L286.236 296.565L279.176 285.716L272.545 277.579L266.055 271.155L259.139 265.802L251.722 263.804L243.878 267.158L236.747 273.154L233.681 274.01L220.846 273.511L217.779 274.653L207.725 284.003L201.093 285.502L194.176 283.575L186.831 279.578L183.123 282.29L171.072 285.502L166.08 289.927L155.027 296.208L151.819 300.49L148.61 296.065L147.968 289.285L150.25 283.146L155.598 280.363L160.518 279.863L162.372 278.793L163.941 274.439L165.938 272.226L182.481 257.951L184.621 254.097L183.123 248.244L179.629 243.604L175.208 240.107L170.858 237.823L168.22 237.038L164.155 236.467L162.301 235.61L160.803 234.112L157.523 229.9L156.24 229.044L151.89 226.974L142.691 217.053L138.198 213.698L133.635 213.341L127.003 214.198L120.942 216.41L118.375 219.908L116.164 226.332L110.816 226.688L93.4165 217.552L89.6371 216.196L86.3568 217.053L84.8594 220.051L85.216 223.834L86.2143 228.187L86.5707 232.613L84.5741 231.042L76.1597 228.116L78.8695 215.197L76.5163 202.992L56.6924 164.021L47.9927 158.382L44.9263 155.313L44.0707 152.244L43.5002 145.321L42.9297 142.038L36.3693 129.333L11.6963 97.428L1 86.793L5.70642 83.7239L7.91698 82.7247L16.1888 81.1545L17.4725 80.1551L18.0428 79.0131L17.9003 77.5857L18.1142 76.0867L19.1838 73.7314L20.396 72.4467L22.3214 71.3047L24.1041 70.5909L26.3147 69.9485L28.3113 68.4497L29.5236 67.3077L30.2367 66.2371L30.8072 65.2377L31.1638 64.1671L31.3777 62.9537L31.235 58.9567L32.376 54.46L31.5202 47.1083L32.6612 39.4714L32.8751 37.2585V35.617L32.0194 33.4756L28.8818 27.3375L29.0245 26.124L29.4523 25.1249L30.3794 24.5537L36.0841 22.6267L37.8668 21.7702L40.9331 19.6291L41.4323 19.2006L47.85 12.3486L49.4188 11.1353L51.2728 10.3501H53.4834L59.0455 13.2766L59.9013 14.2045L60.8282 15.4892L61.4701 17.7018L62.3257 19.8432L69.314 31.6913L70.8115 33.4756L71.6672 34.1182L72.6655 34.6177L77.871 35.7597L84.6455 36.3308L87.3551 36.0453L88.5674 35.7597L89.7084 35.0459V34.1182L89.2805 31.8342L89.1379 30.3353V28.1939L88.7814 26.6237L88.0683 25.0534L87.1412 24.1255L84.8594 22.3411L83.2192 20.5567L82.7201 19.6291L82.4349 18.5582V17.345L82.6488 16.203L83.0053 15.0609L84.1463 13.2052L86.9987 10.0647L87.6404 9.20811L88.6388 7.13828L89.851 5.42523L90.9206 3.06994L91.9903 1.64235L94.2721 2.42748L94.0582 2.57026Z"
        fill="#001A70"
        stroke="#84B5E7"
        strokeMiterlimit="10"
      />

      <SystemTooltip
        onMouseEnter={openFirst}
        className="system-tooltip"
        open={opened === "1"}
        closeTooltip={toggle}
        href={iconsData?.at(0)?.href}
        title={iconsData?.at(0)?.label || "Title"}
      >
        <g onMouseEnter={openFirst} onClick={openFirst}>
          <path
            d="M144.496 176.289C144.496 176.289 146.166 178.731 146.166 182.166C146.166 186.26 144.031 190.037 139.489 191.401C139.537 185.513 135.605 186.965 133.647 182.166C130.237 185.188 130.367 187.941 130.309 191.401C127.474 190.54 124.467 188.069 124.467 183.006C124.467 178.719 127.805 175.526 127.805 172.092C127.805 172.092 130.647 172.623 131.144 176.289C133.944 173.258 134.482 170.489 134.482 167.055C139.129 170.036 140.324 173.083 140.324 178.808C142.219 178.435 143.244 177.623 144.496 176.289Z"
            stroke="white"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M110.338 172.102C112.25 172.643 113.906 172.929 115.339 172.929C124.525 172.93 124.525 164.536 124.525 154.461C120.229 156.982 107.834 156.108 107.834 165.382C107.834 167.203 108.128 169.924 110.338 172.102Z"
            stroke="white"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M127.864 156.979C131.202 156.979 134.315 157.919 136.969 159.547"
            stroke="white"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M119.435 159.473C115.087 162.168 111.189 166.835 110.447 172.141C110.338 172.947 110.28 173.77 110.28 174.609C110.28 183.827 117.307 191.383 126.261 192.164"
            stroke="white"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M127.805 156.979C136.927 156.979 144.413 163.98 145.247 172.938"
            stroke="white"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </SystemTooltip>

      <SystemTooltip
        onMouseEnter={openSecond}
        className="system-tooltip"
        open={opened === "2"}
        closeTooltip={toggle}
        href={iconsData?.at(1)?.href}
        title={iconsData?.at(1)?.label || "Title"}
      >
        <g onClick={openSecond} onMouseEnter={openSecond}>
          <path
            d="M164.496 108.289C164.496 108.289 166.166 110.731 166.166 114.166C166.166 118.26 164.031 122.037 159.489 123.401C159.537 117.513 155.605 118.965 153.647 114.166C150.237 117.188 150.367 119.941 150.309 123.401C147.474 122.54 144.467 120.069 144.467 115.006C144.467 110.719 147.805 107.526 147.805 104.092C147.805 104.092 150.647 104.623 151.144 108.289C153.944 105.258 154.482 102.489 154.482 99.0547C159.129 102.036 160.324 105.083 160.324 110.808C162.219 110.435 163.244 109.623 164.496 108.289Z"
            stroke="white"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M130.338 104.102C132.25 104.643 133.906 104.929 135.339 104.929C144.525 104.93 144.525 96.5362 144.525 86.4609C140.229 88.9816 127.834 88.1085 127.834 97.382C127.834 99.2028 128.128 101.924 130.338 104.102Z"
            stroke="white"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M147.864 88.9785C151.202 88.9785 154.315 89.9188 156.969 91.5474"
            stroke="white"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M139.435 91.4727C135.087 94.1675 131.189 98.8352 130.447 104.141C130.338 104.947 130.28 105.77 130.28 106.609C130.28 115.827 137.307 123.383 146.261 124.164"
            stroke="white"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M147.805 88.9785C156.927 88.9785 164.413 95.9801 165.247 104.938"
            stroke="white"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </SystemTooltip>

      <SystemTooltip
        onMouseEnter={openThird}
        className="system-tooltip"
        open={opened === "3"}
        closeTooltip={toggle}
        href={iconsData?.at(2)?.href}
        title={iconsData?.at(2)?.label || "Title"}
      >
        <g onClick={openThird} onMouseEnter={openThird}>
          <path
            d="M184.496 165.289C184.496 165.289 186.166 167.731 186.166 171.166C186.166 175.26 184.031 179.037 179.489 180.401C179.537 174.513 175.605 175.965 173.647 171.166C170.237 174.188 170.367 176.941 170.309 180.401C167.474 179.54 164.467 177.069 164.467 172.006C164.467 167.719 167.805 164.526 167.805 161.092C167.805 161.092 170.647 161.623 171.144 165.289C173.944 162.258 174.482 159.489 174.482 156.055C179.129 159.036 180.324 162.083 180.324 167.808C182.219 167.435 183.244 166.623 184.496 165.289Z"
            stroke="white"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M150.338 161.102C152.25 161.643 153.906 161.929 155.339 161.929C164.525 161.93 164.525 153.536 164.525 143.461C160.229 145.982 147.834 145.108 147.834 154.382C147.834 156.203 148.128 158.924 150.338 161.102Z"
            stroke="white"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M167.864 145.979C171.202 145.979 174.315 146.919 176.969 148.547"
            stroke="white"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M159.435 148.473C155.087 151.168 151.189 155.835 150.447 161.141C150.338 161.947 150.28 162.77 150.28 163.609C150.28 172.827 157.307 180.383 166.261 181.164"
            stroke="white"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M167.805 145.979C176.927 145.979 184.413 152.98 185.247 161.938"
            stroke="white"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </SystemTooltip>

      <defs>
        <clipPath id="clip0_518_7285">
          <rect
            width="40"
            height="40"
            fill="white"
            transform="translate(107 153)"
          />
        </clipPath>
        <clipPath id="clip1_518_7285">
          <rect
            width="40"
            height="40"
            fill="white"
            transform="translate(147 142)"
          />
        </clipPath>
        <clipPath id="clip2_518_7285">
          <rect
            width="40"
            height="40"
            fill="white"
            transform="translate(127 85)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CampaniaSystemsMap;
